import { Component, Input, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormGroupDirective,
} from '@angular/forms';

@Component({
  selector: 'app-opening-hours-subform',
  templateUrl: './opening-hours-subform.component.html',
  styleUrls: ['./opening-hours-subform.component.scss'],
})
export class OpeningHoursSubformComponent implements OnInit {
  @Input() formGroupName!: string;
  @Input() title: string = 'SHARED.OPENING_HOURS.TITLE';

  form!: UntypedFormGroup;

  DAYS = 'SHARED.OPENING_HOURS.DAYS.';
  DAY = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ];
  hours: string[] = [];

  constructor(private rootFormGroup: FormGroupDirective) {}

  static buildOpeningHoursForm(fb: UntypedFormBuilder): UntypedFormGroup {
    return fb.group({
      monday: fb.group({ from: '', to: '' }),
      tuesday: fb.group({ from: '', to: '' }),
      wednesday: fb.group({ from: '', to: '' }),
      thursday: fb.group({ from: '', to: '' }),
      friday: fb.group({ from: '', to: '' }),
      saturday: fb.group({ from: '', to: '' }),
      sunday: fb.group({ from: '', to: '' }),
    });
  }

  ngOnInit(): void {
    if (!this.formGroupName) {
      throw Error('Attribute "formGroupName" is required');
    }
    this.form = this.rootFormGroup.control.get(
      this.formGroupName
    ) as UntypedFormGroup;

    this.fillHours();
  }

  remove(day: string): void {
    const form = this.form.get(day);
    if (form) {
      form.setValue({ from: '', to: '' });
      form.markAsDirty();
    }
  }

  add(day: string): void {
    const form = this.form.get(day);
    if (form) {
      form.setValue({ from: '08:00', to: '16:00' });
      form.markAsDirty();
    }
  }

  fillHours() {
    for (let i = 0; i < 24; i++) {
      if (i < 10) {
        this.hours.push(`0${i}:00`);
        this.hours.push(`0${i}:15`);
        this.hours.push(`0${i}:30`);
        this.hours.push(`0${i}:45`);
      } else {
        this.hours.push(`${i}:00`);
        this.hours.push(`${i}:15`);
        this.hours.push(`${i}:30`);
        this.hours.push(`${i}:45`);
      }
    }
  }

  get monday(): UntypedFormControl {
    return this.form.get('monday') as UntypedFormControl;
  }
  get tuesday(): UntypedFormControl {
    return this.form.get('tuesday') as UntypedFormControl;
  }
  get wednesday(): UntypedFormControl {
    return this.form.get('wednesday') as UntypedFormControl;
  }
  get thursday(): UntypedFormControl {
    return this.form.get('thursday') as UntypedFormControl;
  }
  get friday(): UntypedFormControl {
    return this.form.get('friday') as UntypedFormControl;
  }
  get saturday(): UntypedFormControl {
    return this.form.get('saturday') as UntypedFormControl;
  }
  get sunday(): UntypedFormControl {
    return this.form.get('sunday') as UntypedFormControl;
  }
}
